<template>
    <model-modal
        component="v-spa-right-panel-modal"
        :model-class="modelClass"
        modal-type="form"
        @opening="onOpening"
        @resetted="onReset"
        right-panel-width="600px"
        right-panel-width-xl="600px"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <h2 class="mb-8 text-xl font-thin text-center text-gray-800" v-text="title"></h2>
            <form @submit.prevent="submit" class="mx-auto max-w-input">
                
                <div class="flex flex-col w-full mb-6 space-y-4">
                    <div class="w-full">
                        <v-spa-label id="activity-form-worksite" :label="$t('form.labels.worksite')"></v-spa-label>
                        <select-worksite :initial-value="form.worksite ? [form.worksite.uuid] : []" @updated="setWorksiteByUuid"></select-worksite>
                    </div>
                    
                    <div class="w-full" v-if="form.worksite">
                        <v-spa-label id="activity-form-worksite-phase" :label="$t('form.labels.worksite-phase')"></v-spa-label>
                        <select :class="$spa.css.form.select" id="activity-form-worksite_phase_uuid" v-model="form.worksite_phase" @change="setWorksitePhase(null, true)">
                            <option :value="null">{{ $t('form.worksite-phase.null') }}</option>
                            <option :value="phase" v-for="phase in form.worksite.phases" :key="phase.uuid">
                                {{ phase.title }}
                            </option>
                        </select>
                    </div>
                    
                    <div class="w-full" v-if="form.worksite_phase && form.worksite_phase.trustup_io.tasks && form.worksite_phase.trustup_io.tasks.tasks.get().length > 0">
                        <v-spa-label id="activity-form-worksite-phase-task" :label="$t('form.labels.worksite-phase-task')"></v-spa-label>
                        <select :class="$spa.css.form.select" id="activity-form-trustup_io_task_uuid" v-model="form.trustup_io_task" @change="setTrustUpIOTask()">
                            <option :value="null">{{ $t('form.worksite-phase-task.null') }}</option>
                            <option :value="task" v-for="task in form.worksite_phase.trustup_io.tasks.tasks.get()" :key="task.uuid">
                                {{ task.title }}
                            </option>
                        </select>
                    </div>
                </div>
                
                <div class="w-full mb-6">
                    <v-spa-label id="activity-form-user" :label="$t('form.labels.user')"></v-spa-label>
                    <select-user :as-field="true" :initial-value="form.user ? [form.user.id] : [$store.state.user.id]" @updated="setUserById"></select-user>
                </div>
                
                <v-spa-input
                    id="time-activity-form-title"
                    :form="form"
                    input-name="title"
                />
                
                <div class="w-full mb-6">
                    <div class="flex items-center justify-between space-x-4">
                        <div>
                            <v-spa-label id="activity-form-day" :label="$t('form.labels.start_end_date')"></v-spa-label>
                            <div class="flex items-center justify-between space-x-4" @submit.prevent="setTimes">
                                <div class="flex items-center space-x-4">
                                    <v-spa-date-picker :popover="{ visibility: 'click' }" :display-label="false" container-class-name="" id="timetracker-modal-form-day" :form="form" input-name="day" @change="onFormChange"></v-spa-date-picker>
                                    <div class="w-[70px]">
                                        <input v-model="form.starts_at" type="text" id="time-activity-form-starts_at" :class="$spa.css.form.input" v-mask="'##:##'" :placeholder="$t('form.times.placeholder')" @change="setTimesSilently" @blur="fixTimes">
                                    </div>
                                    <div class="w-[70px]">
                                        <input v-model="form.ends_at" type="text" id="time-activity-form-ends_at" :class="$spa.css.form.input" v-mask="'##:##'" :placeholder="$t('form.times.placeholder')" @change="setTimesSilently" @blur="fixTimes">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <v-spa-label :class-name="`${$spa.css.form.label} text-center`" id="time-activity-form-total_total" :label="$t('form.labels.total_time')"></v-spa-label>
                            <div class="h-[38px] flex justify-center">
                                <time-difference container-class-name="w-auto" ref="timeDifference" :start="startsAtDate" :end="endsAtDate"></time-difference>
                            </div>
                        </div>
                    </div>
                </div>
                
                <v-spa-textarea :form="form" input-name="comments" id="activity-form-comments"></v-spa-textarea>
                
                <time-activity-modal-planning-predictions
                    :activity="model"
                    :form="form"
                    ref="planningPredictions"
                ></time-activity-modal-planning-predictions>
                
                    
                <div class="flex mt-10 justify-end">
                    <v-spa-loading-button :loading="form.isLoading()">
                        <i class="mr-2 far fa-check"></i>
                        {{ button }}
                    </v-spa-loading-button>
                </div>

            </form>
        </template>
    </model-modal>
</template>

<script>
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import TimeActivity from '@spa/apps/trustup-pro-planning-js/models/TimeActivity';
    import Form from '~spa/classes/Form';
    import UserWeekHours from './FormModal/UserWeekHours';
    import PlanningPredictions from './FormModal/PlanningPredictions';
    import TimeActivityCalendarEventFormsMixin from '@spa/apps/trustup-pro-planning-js/mixins/TimeActivityCalendarEventFormsMixin';

    export default {
        components: {
            ModelModal,
            'time-activity-modal-user-week-hours': UserWeekHours,
            'time-activity-modal-planning-predictions': PlanningPredictions
        },

        mixins: [TimeActivityCalendarEventFormsMixin],

        data() {
            return {
                modelClass: TimeActivity,
                
                form: new Form({
                    day: null,
                    user: this.$store.state.user,
                    starts_at: null,
                    ends_at: null,
                    title: this.$store.state.user.default_title,
                    worksite: null,
                    worksite_phase: null,
                    trustup_io_task: null,
                    calendar_event_id: null,
                    comments: ''
                })
            };
        },

        computed: {
            model()
            {
                return this.$refs.modal?.model || null;
            },
            title()
            {
                return this.model ? this.$t('modals.activity.edit.title') : this.$t('modals.activity.create.title');
            },
            button()
            {
                return this.model ? this.$t('modals.activity.edit.button') : this.$t('modals.activity.create.button');
            }
        },

        methods: {
            onReset()
            {
                this.form.reset();
            },

            onOpening(data)
            {
                this.form.day = window.moment().format('YYYY-MM-DD');
                this.setTimes({
                    starts_at: window.moment().format('HH:mm'),
                    ends_at: window.moment().add(1, 'hour').format('HH:mm'),
                }, false);

                if ( ! this.model ) {
                    this.onFormChange();
                    return;
                }
                
                this.setData({
                    user: this.model.getUser(),
                    title: this.model.title,
                    worksite: this.model.worksite,
                    worksite_phase: this.model.worksitePhase,
                    trustup_io_task: this.model.trustUpIOTask,
                    comments: this.model.comments,
                    calendar_event_id: this.model.calendar_events_ids,
                    day: window.moment(this.model.starts_at).format('YYYY-MM-DD'),
                    times: {
                        starts_at: window.moment(this.model.starts_at).format('HH:mm'),
                        ends_at: window.moment(this.model.ends_at).format('HH:mm'),
                    }
                });
            },

            setData({
                user,
                title,
                worksite = null,
                worksite_phase = null,
                trustup_io_task = null,
                day,
                times,
                comments,
                calendar_event_id = null
            }) {
                this.form.calendar_event_id = Array.isArray(calendar_event_id) && calendar_event_id.length > 0 ? calendar_event_id[0] : null;
                this.form.comments = comments;
                this.form.day = day;
                this.form.title = title;

                this.setWorksite(worksite);
                this.setWorksitePhase(worksite_phase);
                this.setTrustUpIOTask(trustup_io_task);
                this.setUser(user, false, false);
                this.setTimes(times, false);

                this.onFormChange();

                this.$nextTick(() => {
                    this.init();
                });
            },

            async submit()
            {
                if ( this.form.isLoading() ) {
                    return;
                }

                this.form.load();

                let data = await this.getFormData();

                window.Planning.endpoints.timeActivity[this.getMethod()](data)
                    .then((activity) => {
                        this.form.onSuccess({});
                        this.$refs.modal.close();
                    })
                    .catch(data => {
                        if ( typeof data.errors !== "undefined" ) {
                            this.form.onFail({errors: data.errors});
                        }
                    });
            },

            getMethod()
            {
                return this.isUpdating() ? 'update' : 'store';
            },

            async getFormData()
            {
                let data = {
                    starts_at: this.startsAtDate,
                    ends_at: this.endsAtDate,
                    title: this.form.title,
                    comments: this.form.comments,
                    calendar_events: this.form.calendar_event_id ? [].concat(this.form.calendar_event_id) : null,
                    user_id: this.form.user ? this.form.user.id : null,
                    external_worksite_uuid: this.form.worksite !== null && typeof this.form.worksite == 'object' ? this.form.worksite.uuid : null, 
                    external_worksite_phase_uuid: this.form.worksite_phase !== null && typeof this.form.worksite_phase == 'object' ? this.form.worksite_phase.uuid : null,
                    trustup_io_task_uuid: this.form.trustup_io_task !== null && typeof this.form.trustup_io_task == 'object' ? this.form.trustup_io_task.uuid : null,
                }

                return this.isUpdating() ? {...{uuid: this.model.uuid}, ...{data: data}} : data;
            },
            
            onFormChange()
            {
                if ( ! this.form.starts_at ) {
                    return;
                }

                if ( this.$refs.userWeekHours ) {
                    this.$refs.userWeekHours.get();
                }

                if ( this.$refs.planningPredictions ) {
                    this.$refs.planningPredictions.get();
                }
            },

            isUpdating()
            {
                return this.model !== null;
            },
        }
    }
</script>